import useAnalyticsContext from '@client/hooks/useAnalyticsContext';
import VendorAnalytics from '@decorators/vendorAnalytics';
import { useAppSelector } from '@redux/hooks';
import { useCallback, useMemo } from 'react';
import { EVENT_CONTACT_VENDOR } from '../../../../../lib/vendor-recommendation-module/utils/tracking/vrmTrackingContants';

export const useTrackContactStepSubmit = () => {
	const { track } = useAnalyticsContext();
	const vendor = useAppSelector((state) => state.vendor.vendor);

	const baseProperties = useMemo(() => {
		if (!vendor) return {};

		return new VendorAnalytics(vendor).baseEventProps();
	}, [vendor]);

	return useCallback(() => {
		track({
			event: EVENT_CONTACT_VENDOR,
			properties: {
				...baseProperties,
				source_content: 'pricing flow_v2',
				source_page: 'storefront',
			},
		});
	}, [track, baseProperties]);
};
